import { render, staticRenderFns } from "./DocenteRow.vue?vue&type=template&id=7b90ecc8&"
import script from "./DocenteRow.vue?vue&type=script&lang=js&"
export * from "./DocenteRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports